<template>
    <div class="dd">
		<p v-if="loading">Loading...</p>
        <!-- DATMAN can you update livel1 class below -->
        <ol v-else :class="['dd-list', 'level' + (level || 0)]">
            <li v-if="!parentId" class="dd-item">
                <div v-on:click="topLevel" class="dd-handle" style="cursor: pointer;">Top level</div>
            </li>
            <template v-for="item in items">
                <li class="dd-item " :key="item.id">
                    <template v-if="getChildren(item.id).length > 0">
                        <button v-on:click="closeList(item.id)" class="minus" type="button" data-action="collapse" :style="getListState(item.id) ? '' : 'display: none;'">Collapse</button>
                        <button v-on:click="openList(item.id)"  class="add" type="button" data-action="expand" :style="!getListState(item.id) ? '' : 'display: none;'">Expand</button>
						<div v-on:click="selectItem(item)" data-toggle="collapse" class="dd-handle" style="cursor: pointer;">{{item.name}}</div>
                    </template>
					<div v-else v-on:click="selectItem(item)" class="dd-handle collapse" style="cursor: pointer;">{{item.name}}</div>
                </li>
                <template v-if="getListState(item.id)">
                    <nested-list-component
                        v-if="getChildren(item.id).length > 0"
                        v-on:mount="increaseChildren"
                        v-on:destroy="decreaseChildren"
                        :key="(level || 0) + '_' + item.id"
                        :data="localData"
                        :parentId="item.id"
                        :changeQuery="changeQuery"
                        :type="type"
                        :endpoint="endpoint"
                        :level="(level || 0) + 1" />
                </template>
            </template>
            <li v-if="!children" class="dd-item btn-add"><a :href="shortcutLink" class="btn btn-sm btn-success btn-rounded">Add child</a></li>
        </ol>
  </div>
</template>
<script>
import V from 'voca';

export default {

    name: 'nested-list-component',

    components: {

    },

    props: ['type', 'data', 'parentId', 'changeQuery', 'endpoint', 'nested', 'level', 'timestamp'],

    data () {
        return {
			localData: this.data,
			loading: true,
            lists: { },
            children: 0,
        }
    },

    computed: {
        items() {
            return this.getChildren(this.parentId || null);
        },
        hasChildren() {
            return _.get(this.$refs, 'childLists.length') > 0;
        },
        shortcutLink() {
            let link = '#' + this.helpers('uriFormat')(this.endpoint + (this.parentId ? `?parent_id=${this.parentId}` : ''), false);
            return link;
        },
    },

    watch: {
        type(newType) {
            if (this.level > 0) return;
            this.loading = true;
            this.helpers('api')
                .getData(`/${newType}/_ref_`)
                .then(response => {
                    this.localData = this.getHierarchyData(response.data);
                    this.loading = false;
                });
        },
        timestamp() {
            this.helpers('api')
                .getData(`/${this.type}/_ref_`)
                .then(response => {
                    this.localData = this.getHierarchyData(response.data);
                });
        }
    },

    mounted() {
        if (this.localData) {
            this.loading = false;
        } else {
            this.loading = true;
            this.helpers('api')
                .getData(`/${this.type}/_ref_`)
                .then(response => {
                    this.localData = this.getHierarchyData(response.data);
                    this.loading = false;
                });
        }
        this.$emit('mount');
    },

    destroyed() {
        this.$emit('destroy');
    },

    methods: {
        getHierarchyData(data) {
            return data.map((item, index) => {

                return {
                    id: item.id,
                    name: item.name,
                    parentId: item.parent_id,
                    position: item.position || 0,
                }
            });
        },
        getChildren(id) {
            return this.localData
                .filter(({ parentId }) => parentId == id)
                .sort((a, b) => a.position - b.position);
        },
        getListState(id) {
            const state = this.lists[id] || false;
            return state;
        },
        selectItem(item) {
            this.lists = { [item.id]: true };
            const value = item.id || '$null';
            this.changeQuery({
                filter: `parent_id$id:${value}`,
                page: 1,
            });
        },
        openList(id) {
            this.lists[id] = true;
            this.$forceUpdate();
        },
        closeList(id) {
            this.lists[id] = false;
            this.$forceUpdate();
        },
        increaseChildren() {
            this.children += 1;
        },
        decreaseChildren() {
            this.children -= 1;
        },
        topLevel() {
            this.changeQuery({
                filter: 'parent_id:$null',
            });
        },
        reset() {
            this.changeQuery({
                filter: '',
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/table-elements/NestedListComponent.vue